import {
  GET_CAMPAIGN_STICKY_COLUMNS,
  GET_CAMPAIGN_STICKY_COLUMNS_SUCCESS,
  GET_CAMPAIGN_STICKY_COLUMNS_ERROR,
  UPDATE_CAMPAIGN_STICKY_COLUMNS,
  UPDATE_CAMPAIGN_STICKY_COLUMNS_SUCCESS,
  UPDATE_CAMPAIGN_STICKY_COLUMNS_ERROR
} from "./actionTypes"

// FOR GET ADMIN USER ROLE
export const getCampaignStickyColumns = () => {
  return {
    type: GET_CAMPAIGN_STICKY_COLUMNS,
  }
}

export const getCampaignStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_CAMPAIGN_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getCampaignStickyColumnsError = error => {
  return {
    type: GET_CAMPAIGN_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR UPDATE ADMIN USER ROLE
export const updateCampaignStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_CAMPAIGN_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateCampaignStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_CAMPAIGN_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateCampaignStickyColumnsError = error => {
  return {
    type: UPDATE_CAMPAIGN_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}